module.exports = __webpack_public_path__ + "img/xaas-riasat-jomhoori.1d78081.png";